import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import '@/styles/globals.css';
import '@/i18n/config';

import { App } from './App';
import { logger } from './shared/lib/logger';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root not found in document');
}

const appName = import.meta.env['VITE_APP_NAME'] || 'Super Admin';
document.title = appName;

logger.info('Super Admin booting', {
  version: __APP_VERSION__,
  env: import.meta.env['VITE_APP_ENV'],
  appName,
});

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

declare const __APP_VERSION__: string;
